import { render, staticRenderFns } from "./GestaoClienteProdutos.vue?vue&type=template&id=8b716de6"
import script from "./GestaoClienteProdutos.vue?vue&type=script&lang=js"
export * from "./GestaoClienteProdutos.vue?vue&type=script&lang=js"
import style0 from "./GestaoClienteProdutos.vue?vue&type=style&index=0&id=8b716de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports